import { memo, useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
// Import Store
import { useAppSelector } from 'store';
import { selectUserViewMode } from 'store/slices/userData';
// Import Hooks
import useGoToRoute from 'hooks/GoToRoute';
import useQueryParams from 'hooks/UseQueryParams';
//Import Components
import ClientPreview from './ClientPreview';
// Import UI components
import { Popover, PopoverV2 } from '@geneui/components';
// Import Constants
import { RoutesList } from 'routes';
// Import Styles
import 'assets/scss/clientPage.scss';

const { CLIENT_VIEW } = RoutesList;

const ClientId = ({ clientId }) => {
    const [isPopoverVisible, setIsPopoverVisible] = useState(false);
    const { goToRoute, getRoutePath } = useGoToRoute();
    const { search } = useLocation();
    const goToRouteQueryParams = useQueryParams();
    const viewMode = useAppSelector(selectUserViewMode);
    const isSmallView = viewMode < 1;
    const isLargeView = viewMode > 1;

    const buttonOnClick = useCallback(
        (e) => {
            e.preventDefault();
            goToRoute(CLIENT_VIEW, { clientId: clientId }, goToRouteQueryParams.encode({ backParams: search }));
        },
        [goToRoute, clientId, goToRouteQueryParams, search],
    );

    const link = useMemo(() => getRoutePath(CLIENT_VIEW, { clientId: clientId }, null), [getRoutePath, clientId]);

    const PopoverComponent = isSmallView ? PopoverV2 : Popover;

    return (
        <PopoverComponent
            className="crm-client-preview-popover"
            isOpen={isPopoverVisible}
            Content={<ClientPreview clientId={clientId} />}
            position="right"
            align={isSmallView ? 'start' : isLargeView ? 'end' : 'center'}
            disableReposition={false}
        >
            <a
                className="tittle-text ellipsis-text"
                onMouseEnter={() => setIsPopoverVisible(true)}
                onMouseLeave={() => setIsPopoverVisible(false)}
                onClick={buttonOnClick}
                href={link}
            >
                {clientId}
            </a>
        </PopoverComponent>
    );
};

ClientId.propTypes = {
    clientId: PropTypes.number.isRequired,
};

export default memo(ClientId);
